import styled from "styled-components";

const UnstyledButton = styled.button`
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
  appearance: none;
  background-color: transparent;
  border: 0;
  text-align: inherit;
`;

export default UnstyledButton;
